import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';

export interface ConfirmDialogData {
  title: string;
  message: string;
  details?: string[];
  confirmText?: string;
  cancelText?: string;
  confirmColor?: 'primary' | 'accent' | 'warn';
}

@Component({
  selector: 'app-confirm-reset-dialog',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatDialogModule],
  template: `
    <div class="confirm-dialog">
      <h2 mat-dialog-title>
        <mat-icon color="warn" class="warning-icon">warning</mat-icon>
        {{ data.title }}
      </h2>

      <mat-dialog-content>
        <p class="message">{{ data.message }}</p>

        @if (data.details && data.details.length > 0) {
        <div class="details">
          <ul>
            @for (detail of data.details; track detail) {
            <li>{{ detail }}</li>
            }
          </ul>
        </div>
        }
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()">
          {{ data.cancelText || 'Annuller' }}
        </button>
        <button
          mat-raised-button
          [color]="data.confirmColor || 'warn'"
          (click)="onConfirm()"
        >
          {{ data.confirmText || 'Bekræft' }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .confirm-dialog {
        padding: 0;
      }

      .warning-icon {
        margin-right: 8px;
        vertical-align: middle;
      }

      .message {
        font-size: 16px;
        margin-bottom: 16px;
        line-height: 1.5;
      }

      .details {
        background-color: #f5f5f5;
        padding: 16px;
        border-radius: 4px;
        margin-top: 16px;
      }

      .details ul {
        margin: 0;
        padding-left: 20px;
      }

      .details li {
        margin-bottom: 8px;
        line-height: 1.4;
      }

      mat-dialog-actions {
        padding: 16px 0 0 0;
        margin: 0;
      }

      mat-dialog-actions button {
        margin-left: 8px;
      }
    `,
  ],
})
export class ConfirmResetDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmResetDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
